import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './shared/_helpers/authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'lideum-frontend';
  constructor(private _authenticationService: AuthenticationService, public translate: TranslateService) {
    translate.addLangs(['de', 'it']);

    const browserLang = translate.getBrowserLang();
    if (localStorage.getItem('userDataLang')) {
      translate.use(localStorage.getItem('userDataLang'));
      translate.setDefaultLang(localStorage.getItem('userDataLang'));
    } else {
      const lang = browserLang.match(/de|it/) ? browserLang : 'de';
      translate.use(lang);
      localStorage.setItem('userDataLang', lang);
      translate.setDefaultLang(lang);
    }
  }

  ngOnInit(): void {
    this._authenticationService.autoLogin();
  }

}
